<template>
  <div>
    <!-- section 区分模块-->
    <div class="section">
      <div v-for="item in formElementList" :key="item">
        <!-- input输入框 -->
        <div class="label" v-if="item.InputType=='input'">
          <div class="label-title">
            <span class="red" v-if="item.IsRequired">*</span>
            {{item.Title}}
          </div>
          <div class="input">
            <input type="text" :placeholder="item.Placeholder" v-model="item.InputValue">
          </div>
        </div>

        <div class="label" v-if="item.InputType=='number'">
          <div class="label-title">
            <span class="red" v-if="item.IsRequired">*</span>
            {{item.Title}}
          </div>
          <div class="input">
            <input type="number" :placeholder="item.Placeholder" v-model="item.InputValue">
          </div>
        </div>
        <div class="label" v-if="item.InputType=='email'">
          <div class="label-title">
            <span class="red" v-if="item.IsRequired">*</span>
            {{item.Title}}
          </div>
          <div class="input">
            <input type="email" :placeholder="item.Placeholder" v-model="item.InputValue">
          </div>
        </div>
        <div class="label" v-if="item.InputType=='date'">
          <div class="label-title">
            <span class="red" v-if="item.IsRequired">*</span>
            {{item.Title}}
          </div>
          <div class="input">
            <input type="date" :placeholder="item.Placeholder" v-model="item.InputValue">
          </div>
        </div>
        <!-- 文本框 -->
        <div class="label" v-if="item.InputType=='textarea'">
          <div class="label-title">
            <span class="red" v-if="item.IsRequired">*</span>
            {{item.Title}}
          </div>
          <div class="textarea">
            <textarea
              name
              id
              cols="30"
              rows="10"
              :placeholder="item.Placeholder"
              v-model="item.InputValue"
            ></textarea>
          </div>
        </div>
        <!-- 单选 -->
        <div class="label" v-if="item.InputType=='radio'">
          <div class="label-title">
            <span class="red" v-if="item.IsRequired">*</span>
            {{item.Title}}
          </div>
          <div class="radio-group clearfix">
            <label class="radio clearfix" v-for="option in item.Options" :key="option">
              <input type="radio" :value="option" :name="item.Key" v-model="item.InputValue">
              <i></i>
              <div class="item">{{option}}</div>
            </label>
          </div>
        </div>

        <!-- 多选 （可能用不到）-->
        <div class="label" v-if="item.InputType=='checkbox'">
          <div class="label-title">
            <span class="red" v-if="item.IsRequired">*</span>
            {{item.Title}}
          </div>
          <div class="checkbox-group clearfix">
            <label class="checkbox" v-for="option in item.Options" :key="option">
              <input type="checkbox" :name="item.Key" :value="option" v-model="item.OptionArray">
              <i></i>
              <div class="item">{{option}}</div>
            </label>
          </div>
        </div>
        <!-- select 选择 -->
        <div class="label" v-if="item.InputType=='select'">
          <div class="label-title">
            <span class="red" v-if="item.IsRequired">*</span>
            {{item.Title}}
          </div>
          <div class="select">
            <select :name="item.Key" v-model="item.InputValue">
              <option v-for="option in item.Options" :value="option" :key="option">{{option}}</option>
            </select>
            <i></i>
          </div>
        </div>
      </div>
    </div>
    <div class="form-element-loading" v-show="!formElementList || !formElementList.length">处理中...</div>
    <slot name="privacyAgreement"></slot>
    <button
      class="btn-main btn-submit"
      type="button"
      v-show="formElementList && formElementList.length"
      @click="submitForm"
      :disabled="disabled"
    >提交申请</button>
  </div>
</template>

<script>
export default {
  props: {
    getCustomFormUrl: '',
    getCustomFormParams: {},
    disabled: false
  },
  data() {
    return {
      time: '2018-01-01',
      formElementList: [],
      provinceId: 0,
      cityId: 0,
      areaId: 0,
      provinceName: '',
      cityName: '',
      areaName: '',
      provinceStr: ''
    }
  },
  created() {
    this.getCustomFormInfo()
  },
  methods: {
    getCustomFormInfo() {
      let _this = this
      this.$fetch(this.getCustomFormUrl, this.getCustomFormParams).then(result => {
        this.$emit('formLoaded', result)
        this.formElementList = result
        if (this.formElementList === null || this.formElementList.length === 0) {
          this.$emit('form-empty')
          return
        }
        for (var index in this.formElementList) {
          var item = this.formElementList[index]
          if (item.InputType == 'province') {
            var arr = item.InputValue.split(',')
            _this.provinceId = arr[0]
            _this.cityId = arr[1]
            _this.areaId = arr[2]
            _this.provinceName = item.ValueArrary[0]
            _this.cityName = item.ValueArrary[1]
            _this.areaName = item.ValueArrary[2]
            _this.provinceStr = _this.provinceId + ',' + _this.cityId + ',' + _this.areaId
          }
        }
      })
    },
    onSelected(data) {
      this.provinceID = data.province.code
      this.cityID = data.city.code
      this.areaID = data.area.code
      this.provinceStr = this.provinceID + ',' + this.cityID + ',' + this.areaID
      console.log(this.provinceStr)
    },
    submitForm() {
      let _this = this
      for (var index in _this.formElementList) {
        var item = _this.formElementList[index]
        if (item.InputType == 'province') {
          item.InputValue = _this.provinceStr
        }
        if (item.InputType == 'checkbox') {
          if (item.IsRequired && item.OptionArray.length == 0) {
            this.$dialog.toast({
              mes: item.Title + '不能为空',
              timeout: 1500
            })
            return false
          }
        } else {
          if (item.IsRequired && _this.validNull(item.InputValue)) {
            this.$dialog.toast({
              mes: item.Title + '不能为空',
              timeout: 1500
            })
            return false
          }
        }
      }
      console.log(this.formElementList)
      this.$emit('submitEvent', this.formElementList)
    }
  }
}
</script>

<style lang="less" scoped>
.mat-10 {
  margin-top: 20 / @rem-size;
}

.section {
  width: 100%;
  height: auto;
  background: #fff;
  padding-bottom: 20 / @rem-size;

  .section-title {
    background: #f7f7f7;
    padding-left: 35 / @rem-size;
    line-height: 80 / @rem-size;
    font-size: 28 / @rem-size;
    color: #999999;
  }

  .label {
    width: 100%;
    padding: 25 / @rem-size 24 / @rem-size 0;

    .label-title {
      font-size: 28 / @rem-size;
      color: #333;
    }

    .checkbox-group {
      display: block;
      margin-top: 15 / @rem-size;

      .checkbox {
        display: block;
        overflow: hidden;
        margin-top: 30 / @rem-size;
        //   line-height: 80 / @rem-size;
        font-size: 28 / @rem-size;
        color: #3e3e3e;
        position: relative;
        box-sizing: border-box;

        i {
          display: block;
          width: 34 / @rem-size;
          height: 32 / @rem-size;
          background: url('../assets/images/radio-checkbox-bg.png') 0 0 no-repeat;
          background-size: cover;
          float: left;
          background-position: -34 / @rem-size 0;
        }

        .item {
          padding-left: 20 / @rem-size;
          max-width: 630 / @rem-size;
          float: left;
        }

        input[type='checkbox'] {
          -webkit-appearance: none !important;
          display: none;

          &:checked {
            + i {
              background-position: 0 0;
            }
          }
        }
      }
    }
  }
}

.foot-hint {
  font-size: 24 / @rem-size;
  color: #999;
  padding: 30 / @rem-size 24 / @rem-size 0;
  line-height: 35 / @rem-size;

  span {
    color: #0563d8;
  }
}

.btn-submit {
  display: block;
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  margin: auto;
  margin-top: 35 / @rem-size;
  border-radius: 8 / @rem-size;
}
.btn-submit[disabled] {
  opacity: 0.3;
}

.margin-left-10 {
  margin-left: 20 / @rem-size;
}
.form-element-loading {
  text-align: center;
  padding: 80 / @rem-size;
  font-size: 30 / @rem-size;
}
</style>
